import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import YmapPlugin from 'vue-yandex-maps';

Vue.use(YmapPlugin);

export const bus = new Vue();

Vue.config.productionTip = false;
Vue.config.performance = true;

// mask fo phone number
Vue.filter('phone', function (phone) {
    const formatPhone = `+${phone.replace(
        /^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2}).*/,
        '$1-$2-$3-$4-$5'
    )}`;

    return formatPhone;
});

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
